import type { TPageTranslations } from '@crehana/i18n';

import { ATS_PUBLIC_CAREER_SITE } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof ATS_PUBLIC_CAREER_SITE> = {
  [ATS_PUBLIC_CAREER_SITE]: {
    VACANCY: 'Vaga',
    DEPARTMENT: 'Departamento',
    POSITION: 'Cargo',
    CLOSED_DATE: 'Data de fechamento',
    PUBLISHED_DATE: 'Publicado há {{days}} dias',
    SEARCH_BY_NAME: 'Buscar por nome',
    DAY: 'dia',
    MONTH: 'mês',
    YEAR: 'ano',
    DAYS: 'dias',
    MONTHS: 'meses',
    YEARS: 'anos',
    CLOSED_DATE_CARD: 'Data de fechamento: {{date}}',
    FILTER_BY: 'Filtrar por',
    SEARCH_BY_DEPARTMENT: 'Buscar por departamento',
    NO_DEPARTMENTS_FOUND: 'Não foram encontrados departamentos',
    TRY_ANOTHER_SEARCH: 'Tentar outra busca',
    VACANCY_EXAMPLE: 'Vaga de exemplo',
    OPEN_DATE_EXAMPLE: 'Publicado há 3 dias',
    DEPARTMENT_EXAMPLE: 'Departamento de exemplo',
    RETRY: 'Tentar novamente',
    ERROR_PAGE_TITLE_CAREER_SITE: 'Erro ao carregar o portal de emprego',
    ERROR_PAGE_DESCRIPTION_CAREER_SITE:
      'Ocorreu um erro ao carregar o portal de emprego. Por favor, tente novamente.',
    CAREER_SITE_STATUS_TITLE_NOT_FOUND: 'Portal de emprego não encontrado',
    CAREER_SITE_STATUS_DESCRIPTION_NOT_FOUND:
      'O portal de emprego que você está procurando não existe ou foi removido.',
  },
};
